import { Tooltip } from 'antd'
import AntdAvatar from 'components/Avatar'
import Flex from 'components/Flex'
import Pagination from 'components/Pagination'
import {
  FlexWrap,
  RowNumberData,
} from 'components/TableStyles/TableContentStyles/TableContentStyles'
import { StyledTable } from 'components/TableStyles/TableStyles'
import {
  AlertText,
  CapitalizeText,
  StyledAlert,
} from 'components/UIComponents/FormStyles'
import AlertIconYellow from 'components/icons/AlertIconYellow'
import GreenStarIcon from 'components/icons/GreenStarIcon'
import PlusBlueIcon from 'components/icons/PlusBlueIcon'
import SuccessIcon from 'components/icons/SuccessIcon'
import JDStatus from 'modules/Roles/Partials/RolesTable/RoleStatus/JDStatus'
import AddRoleToExistingDriveDrawer from 'modules/Roles/ViewRole/CollegesTable/AddRoleToExistingDriveDrawer'
import CollegeFilter from 'modules/Roles/ViewRole/CollegesTable/CollegeFilter'
import CollegeStatus from 'modules/Roles/ViewRole/CollegesTable/CollegeStatus'
import ViewActionDropdown from 'modules/Roles/ViewRole/CollegesTable/ViewActionDropdown/index'
import {
  AddSameDriveButton,
  AlertFlex,
} from 'modules/Roles/ViewRole/Style/style'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router'
import { useParams } from 'react-router-dom'
import { COLORS } from 'theme'
import { getIdFormate } from 'utils/getZeroBeforeInt'

const expandedRowRender = (
  record,
  sameDriveLoading,
  handleSameDriveOnClik,
  navigate
) => {
  return (
    <AlertFlex column>
      {record?.instituteCampus?.instituteCampusjobRoleDriveMap
        ?.filter(item => item?.roleId != record?.jobId)
        ?.map((item, index) => {
          let driveData =
            record?.instituteCampus?.instituteCampusjobRoleDriveMap
              ?.filter(drive => drive?.roleId == record?.jobId)
              ?.map(data => data?.driveId)

          return (
            <>
              {driveData?.includes(item?.driveId) ? (
                <StyledAlert
                  backgroundColor={COLORS.GREEN_T_80}
                  key={index + 'success'}
                  type="success"
                  showIcon
                  icon={<SuccessIcon />}
                  message={
                    <Flex spaceBetween alignCenter>
                      <AlertText>
                        Added to the '
                        <CapitalizeText>
                          {item?.driveMode
                            ?.split('_')
                            ?.join(' ')
                            ?.toLowerCase()}
                        </CapitalizeText>
                        ' ID - {getIdFormate(item?.driveSerialNo)}
                      </AlertText>
                      <AddSameDriveButton
                        text="View Drive"
                        onClick={() => navigate(`/drives/${item?.driveId}`)}
                      />
                    </Flex>
                  }
                />
              ) : (
                <StyledAlert
                  key={index + 'warning'}
                  type="warning"
                  showIcon
                  icon={<AlertIconYellow />}
                  message={
                    <Flex spaceBetween alignCenter>
                      <AlertText>
                        Requested '
                        <CapitalizeText>
                          {item?.driveMode
                            ?.split('_')
                            ?.join(' ')
                            ?.toLowerCase()}{' '}
                        </CapitalizeText>
                        ({getIdFormate(item?.driveSerialNo)})' for the role '
                        {item?.roleName}
                        '. Would like to add this role to the same drive?
                      </AlertText>
                      <AddSameDriveButton
                        text="Add to same drive"
                        icon={<PlusBlueIcon />}
                        loading={sameDriveLoading}
                        onClick={() => handleSameDriveOnClik(item?.driveId)}
                      />
                    </Flex>
                  }
                />
              )}
            </>
          )
        })}
    </AlertFlex>
  )
}

const CollegesTable = ({
  getAppliedCollegesList,
  setCollegeDataLength,
  setSelectedCity,
  setSelectedCityName,
  setHostCollegeId,
  setSelectedInstitute,
  setSearchCity,
  setPoolInstituteIds,
  setPoolInstitutesData,
  selectedRowkeys,
  setSelectedRowKeys,
  degreeListData,
  degreeSearch,
  setDegreeSearch,
  singleRoleData,
  getIndidualDriveData,
  driveData,
  getRolesMetrics,
  driveRolesMetrics,
  getAppliedCandidateList,
  addRoleToExistingDrive,
  createDriveDrawer,
  previewDrawer,
  getListOfDrives,
  getDegreesBasedOnRoles,
  roleBasedDegreeList,
  cityRoleData,
  locationSearch,
  setLocationSearch,
  cityData,
  loadMore,
}) => {
  const params = useParams()
  const navigate = useNavigate()
  let pageLimit = 10
  const [collegeTableData, setCollegeTableData] = useState({})
  const [collegesFilterData, setCollegesFilterData] = useState({
    location: '',
    rankingStart: '',
    rankingEnd: '',
    tiers: '',
    candidateStart: '',
    candidateEnd: '',
    driveStatus: '',
    status: '',
  })
  const [searchValue, setSearchValue] = useState('')
  const [locationValue, setLocationValue] = useState('')
  const [collegeRankValue, setCollegeRankValue] = useState({
    start: '',
    end: '',
  })
  const [collegeTierValue, setCollegeTierValue] = useState('')
  const [jdValue, setJDValue] = useState('')
  const [driveStatusValue, setDriveStatusValue] = useState('')
  const [candidateRangeMin, setCandidateRangeMin] = useState('')
  const [candidateRangeMax, setCandidateRangeMax] = useState('')
  const [loading, setLoading] = useState(false)

  const [sortBy, setSortBy] = useState('')
  const [orderBy, setOrderBy] = useState('')

  const [existingDrivePreview, setExistingDrivePreview] = useState(false)
  const [sameDriveLoading, setSameDriveLoading] = useState(false)
  const [pageNum, setPageNum] = useState(0)
  const [count, setCount] = useState(1)

  useEffect(() => {
    setPageNum(0)
    setCount(prev => prev + 1)
  }, [collegesFilterData, searchValue])

  const fetchCollegeData = async () => {
    let res = await getAppliedCollegesList({
      roleId: params?.jobId,
      searchValue: searchValue?.trim(),
      sortby: sortBy,
      orderby: orderBy,
      filterData: collegesFilterData,
      setLoading: setLoading,
      pageLimit: pageLimit,
      pageNum: pageNum,
    })
    let { data, status } = res
    if (status >= 200 && status < 300) {
      setCollegeTableData(data?.data)
      setCollegeDataLength(data?.data?.count)
    }
    if (status >= 400) {
      setCollegeTableData({})
    }
  }

  useEffect(() => {
    let getData
    if (!createDriveDrawer && !previewDrawer) {
      if (searchValue) {
        getData = setTimeout(() => {
          fetchCollegeData()
        }, 500)
      } else {
        fetchCollegeData()
      }
    }
    return () => clearTimeout(getData)
  }, [sortBy, orderBy, createDriveDrawer, previewDrawer, pageNum, count])

  const handleSameDriveOnClik = async driveId => {
    setSameDriveLoading(true)
    const response = await getIndidualDriveData(driveId)
    const metricResponse = await getRolesMetrics(driveId)

    if (
      response?.status >= 200 &&
      response?.status <= 300 &&
      metricResponse?.status >= 200 &&
      metricResponse?.status <= 300
    ) {
      setSameDriveLoading(false)
      setExistingDrivePreview(true)
    } else {
      setSameDriveLoading(false)
    }
  }

  const columns = [
    {
      title: 'College Name',
      dataIndex: 'campusName',
      sorter: true,
      render: (item, { instituteCampus, candidates }) => {
        const CollegeItem = (
          <FlexWrap alignCenter gap="8px">
            <AntdAvatar
              src={instituteCampus?.campusLogoUrl}
              size={25}
              IconName={instituteCampus?.campusName?.split('')[0]}
            />
            <RowNumberData>
              <Tooltip title={instituteCampus?.campusName}>
                {instituteCampus?.campusName?.length > 16
                  ? instituteCampus?.campusName?.substr(0, 16) + '...'
                  : instituteCampus?.campusName}
              </Tooltip>
            </RowNumberData>
          </FlexWrap>
        )
        return CollegeItem // Return the JSX for rendering
      },
    },

    {
      title: 'Location',
      dataIndex: 'city',
      sorter: true,
      render: (item, { instituteCampus }) => (
        <RowNumberData>{instituteCampus?.city}</RowNumberData>
      ),
    },
    {
      title: 'Tier',
      dataIndex: 'tier',
      render: (item, { instituteCampus }) => (
        <RowNumberData>Tier {instituteCampus?.institute?.tier}</RowNumberData>
      ),
    },
    {
      title: 'Total Cand',
      dataIndex: 'candidates',
      render: totalCand => <RowNumberData>{totalCand}</RowNumberData>,
    },
    // {
    //   title: 'Candidate Average Rating',
    //   dataIndex: 'candidateAvgRating',
    //   hidden: !singleRoleData?.isRankingActive,
    //   render: avgRank =>
    //     Number(avgRank) > 0 ? (
    //       <FlexWrap gap="8px">
    //         <RowNumberData>{Number(avgRank)?.toFixed(2)}</RowNumberData>
    //         <AntdAvatar
    //           size={22}
    //           IconName={<GreenStarIcon />}
    //           background="none"
    //         />
    //       </FlexWrap>
    //     ) : (
    //       '0'
    //     ),
    // },
    {
      title: 'JD Status',
      dataIndex: 'status',
      render: (status, row) => (
        <JDStatus status={status} rejectedReason={row.rejectedReason ?? null} />
      ),
    },
    // {
    //   title: 'Drive   ',
    //   dataIndex: 'instituteCampus',
    //   render: (item, data) => {
    //     const filteredItems = item?.instituteCampusjobRoleDriveMap?.filter(
    //       item => item?.roleId == data?.jobId
    //     );
    //          // Use the last item's corporateStatus for the label
    //     const label = filteredItems?.length ? (
    //       <CollegeStatus
    //         status={filteredItems[filteredItems?.length - 1]?.corporateStatus} // Use last item's corporateStatus
    //       />
    //     ) : (
    //       '-'
    //     );
    
    //     return label;
    //   },
    // },       
    {
      title: 'Action',
      dataIndex: 'instituteCampusId',
      render: (item, { instituteCampusId, candidates }) => {
        return (
          <ViewActionDropdown
            instituteCampusId={instituteCampusId}
            candidates={candidates}
          />
        )
      },
    },
  ].filter(item => !item.hidden)

  const resetDriveStates = () => {
    setSelectedCity('')
    setSelectedCityName('')
    setSearchCity('')
    setHostCollegeId('')
    setSelectedInstitute({})
    setPoolInstituteIds('')
    setPoolInstitutesData([])
  }

  const rowSelection = {
    selectedRowKeys: selectedRowkeys,
    onChange: (rowKeysSelected, selectedRows) => {
      setSelectedRowKeys(rowKeysSelected)
      if (selectedRows?.length) {
        if (selectedRows?.length == '1') {
          setSelectedCity(selectedRows[0]?.instituteCampus?.cityId)

          setSearchCity(selectedRows[0]?.instituteCampus?.city)
          setHostCollegeId(selectedRows[0]?.instituteCampusId)
          const instituteCampusDetails = selectedRows[0]?.instituteCampus
          const instituteData = {
            jobId: params?.jobId,
            instituteCampusId: selectedRows[0]?.instituteCampusId,
            id: selectedRows[0]?.instituteCampusId,
            tier: instituteCampusDetails?.institute?.tier,
            instituteCampusName: instituteCampusDetails?.campusName,
            campusName: instituteCampusDetails?.campusName,
            campusLogoUrl: instituteCampusDetails?.campusLogoUrl,
            campusLocation: instituteCampusDetails?.city,
            ranking: instituteCampusDetails?.institute?.ranking,
            cityId: instituteCampusDetails?.cityId,
          }
          setSelectedInstitute(instituteData)
        } else {
          setSelectedCity(selectedRows[0]?.instituteCampus?.cityId)
          setSelectedCityName(collegesFilterData?.location)
          setSearchCity(collegesFilterData?.location)
          setPoolInstituteIds(rowKeysSelected)
          setPoolInstitutesData(selectedRows)
        }
      } else {
        resetDriveStates()
      }
    },
  }

  const handleSort = (page, search, filter) => {
    if (filter?.order) {
      let sort = filter?.order == 'ascend' ? 'asc' : 'desc'
      setSortBy(filter?.field)
      setOrderBy(sort)
    } else {
      setOrderBy('')
      setSortBy('')
    }
  }

  const reloadPage = () => {
    fetchCollegeData()
    getListOfDrives()
  }

  const onPageChange = value => {
    setPageNum(value)
  }

  return (
    <>
      <CollegeFilter
        cityData={cityData}
        loadMore={loadMore}
        cityRoleData={cityRoleData}
        appliedCollegesList={collegeTableData}
        collegesFilterData={collegesFilterData}
        setCollegesFilterData={setCollegesFilterData}
        locationValue={locationValue}
        setLocationValue={setLocationValue}
        collegeRankValue={collegeRankValue}
        setCollegeRankValue={setCollegeRankValue}
        collegeTierValue={collegeTierValue}
        setCollegeTierValue={setCollegeTierValue}
        setJDValue={setJDValue}
        jdValue={jdValue}
        driveStatusValue={driveStatusValue}
        setDriveStatusValue={setDriveStatusValue}
        candidateRangeMin={candidateRangeMin}
        setCandidateRangeMin={setCandidateRangeMin}
        candidateRangeMax={candidateRangeMax}
        setCandidateRangeMax={setCandidateRangeMax}
        searchValue={searchValue}
        setSearchValue={setSearchValue}
        singleRoleData={singleRoleData}
        setLocationSearch={setLocationSearch}
        locationSearch={locationSearch}
      />

      {!!collegeTableData?.result?.length && (
        <StyledTable
          rowSelection={{
            type: collegesFilterData?.location ? 'checkbox' : 'radio',
            ...rowSelection,
          }}
          rowKey="instituteCampusId"
          columns={columns}
          dataSource={collegeTableData?.result}
          loading={loading}
          onChange={handleSort}
          pagination={false}
          expandedRowPadding={'5px'}
          expandable={{
            defaultExpandAllRows: true,
            showExpandColumn: false,
            expandedRowRender: record =>
              expandedRowRender(
                record,
                sameDriveLoading,
                handleSameDriveOnClik,
                navigate
              ),
            rowExpandable: record =>
              !!record?.instituteCampus?.instituteCampusjobRoleDriveMap?.filter(
                item => item?.roleId != record?.jobId
              )?.length,
          }}
        />
      )}
      {!collegeTableData?.result?.length && (
        <StyledTable columns={columns} dataSource={[]} loading={loading} />
      )}

      {collegeTableData?.count > 0 && (
        <Pagination
          onChange={onPageChange}
          totalPages={collegeTableData?.totalPage * 10}
          pageSize={pageLimit}
          current={pageNum || pageNum + 1}
        />
      )}

      <AddRoleToExistingDriveDrawer
        existingDrivePreview={existingDrivePreview}
        setExistingDrivePreview={setExistingDrivePreview}
        degreeListData={degreeListData}
        degreeSearch={degreeSearch}
        setDegreeSearch={setDegreeSearch}
        driveData={driveData || {}}
        driveRolesMetrics={
          Object.keys(driveRolesMetrics)?.length || driveRolesMetrics?.length
            ? driveRolesMetrics
            : []
        }
        singleRoleData={singleRoleData}
        getAppliedCandidateList={getAppliedCandidateList}
        addRoleToExistingDrive={addRoleToExistingDrive}
        reloadPage={reloadPage}
        getDegreesBasedOnRoles={getDegreesBasedOnRoles}
        roleBasedDegreeList={roleBasedDegreeList}
      />
    </>
  )
}

export default CollegesTable
